import ApiService from "../../ApiService";

const FeedbackSuggestionService = {
    saveFeedbackSuggestion: (saveVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/feedbacksuggestion/savefeedbacksuggestion", { saveVO }, successCallback, failureCallback);
    },
    reportLetterError: (errorVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/feedbacksuggestion/reportlettererror", errorVO, successCallback, failureCallback);
    },
    reportWordError: (errorVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/feedbacksuggestion/reportworderror", errorVO, successCallback, failureCallback);
    },
    reportUnitError: (errorVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/feedbacksuggestion/reportuniterror", errorVO, successCallback, failureCallback);
    },
};

export default FeedbackSuggestionService;
